import { FaroErrorBoundary } from "@grafana/faro-react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "routes";
import ErrorBoundary from "components/ErrorBoundary";

const App = () => (
  <Router>
    <FaroErrorBoundary fallback={<h2>Something went wrong</h2>}>
      {/* <ErrorBoundary> use only in local for ui debugging*/}
      <Routes />
      {/* </ErrorBoundary> */}
    </FaroErrorBoundary>
  </Router>
);

export default App;
